import { getProductWithVariants, ProductWithVariants } from '../../models/product';

export const fahhradSchuelerOld: ProductWithVariants = getProductWithVariants({
    slug: 'schueler-fahrrad-versicherung-old',
    title: 'Schüler-Fahrrad-Versicherung',
    insuranceTypeName: 'Fahrrad Schüler',
    insuranceTypeId: 7,
    orderConfig: { steps: [] },
    legacy: true,
});

export const schuelerSachschadenUndHaftpflicht: ProductWithVariants = getProductWithVariants({
    slug: 'schueler-haftpflicht-und-sachschadenversicherung',
    title: 'Schüler-Haftpflicht- und Sachschadenversicherung',
    collapsableTitle: 'Schüler-Haftpflicht- und Sachschaden&shy;versicherung',
    insuranceTypeName: 'Schüler-Sachschaden-Haftpflicht',
    insuranceTypeId: 16,
    orderConfig: { steps: [] },
    legacy: true,
});

export const schuelerKombischutzJ: ProductWithVariants = getProductWithVariants({
    slug: 'schueler-kombischutz-j',
    title: 'Schüler-Kombischutz',
    insuranceTypeName: 'Schüler-Kombischutz (J)',
    insuranceTypeId: 18,
    orderConfig: { steps: [] },
    legacy: true,
});

export const schuelerKombischutzM: ProductWithVariants = getProductWithVariants({
    slug: 'schueler-kombischutz-m',
    title: 'Schüler-Kombischutz',
    insuranceTypeName: 'Schüler-Kombischutz (M)',
    insuranceTypeId: 17,
    orderConfig: { steps: [] },
    legacy: true,
});

export const tabletSchueler: ProductWithVariants = getProductWithVariants({
    slug: 'tablet-schueler',
    title: 'Tablet- und Notebook-Versicherung',
    insuranceTypeName: 'Tablet Schüler',
    insuranceTypeId: 15,
    orderConfig: { steps: [] },
    legacy: true,
});

export const nachhilfeOld: ProductWithVariants = getProductWithVariants({
    slug: 'nachhilfe-old',
    title: 'Nachhilfeversicherung',
    insuranceTypeName: 'Nachhilfe',
    insuranceTypeId: -1,
    orderConfig: { steps: [] },
    legacy: true,
});

export const xxlKombischutzJ: ProductWithVariants = getProductWithVariants({
    slug: 'xxl-kombischutz-j',
    title: 'XXL-Schüler-Kombischutz',
    insuranceTypeName: 'XXL Schüler Kombischutz (J)',
    insuranceTypeId: 12,
    orderConfig: { steps: [] },
    legacy: true,
});

export const xxlKombischutzM: ProductWithVariants = getProductWithVariants({
    slug: 'xxl-kombischutz-m',
    title: 'XXL-Schüler-Kombischutz',
    insuranceTypeName: 'XXL Schüler Kombischutz (M)',
    insuranceTypeId: 11,
    orderConfig: { steps: [] },
    legacy: true,
});
